import React from 'react';
import {Link} from "react-router-dom";

const AddressUrl = () => {
    return (
        <div className="d-flex flex-column">
            <Link to="/">home</Link>
            <Link to="/address">address</Link>
            <Link to="/skeletonSingleProduct">skeletonSingleProduct</Link>
            <Link to="/skeletonProducts">skeletonProducts</Link>
            <Link to="/homePageSkeleton">homePageSkeleton</Link>
            <Link to="/successLoginVendor">successLoginVendor</Link>
            <Link to="/vendorUploadFile">vendorUploadFile</Link>
            <Link to="/vendorInformation">vendorInformation</Link>
            <Link to="/vendorLoginCode">vendorLoginCode</Link>
            <Link to="/vendorLogin">vendorLogin</Link>
            <Link to="/vendorHomePage">vendorHomePage</Link>
            <Link to="/brandPage">brandPage</Link>
            <Link to="/singleBundlePage">singleBundlePage</Link>
            <Link to="/specialOfferPage">specialOfferPage</Link>
            <Link to="/bundlesPage">bundlesPage</Link>
            <Link to="/emailProfile">emailProfile</Link>
            <Link to="/commentsProfile">commentsProfile</Link>
            <Link to="/address">address</Link>
            <Link to="/orderDetails">orderDetails</Link>
            <Link to="/orders">orders</Link>
            <Link to="/counter">counter</Link>
            <Link to="/error">error</Link>
            <Link to="/success">success</Link>
            <Link to="/productDelivery">productDelivery</Link>
            <Link to="/infoUser">infoUser</Link>
            <Link to="/finalApproval">finalApproval</Link>
            <Link to="/cartPage">cartPage</Link>
            <Link to="/singlePage">singlePage</Link>
            <Link to="/comparisonPage">comparisonPage</Link>
            <Link to="/products">products</Link>
            <Link to="/login">login</Link>

        </div>
    );
};

export default AddressUrl;
